/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleUpIcon20Solid = forwardRef('ArrowFigureACircleUpIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 12.9a.9.9 0 0 1-.9-.9V7.994L7.564 9.687a.9.9 0 1 1-1.333-1.21l2.362-2.602a1.9 1.9 0 0 1 2.814 0l2.362 2.602a.9.9 0 1 1-1.333 1.21L10.9 7.994V14a.9.9 0 0 1-.9.9Z" })));
});
